module.exports = "../../app/cells/components/applied_test/show.erb";